exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.affaire-list .el-table td.el-table__cell div {\n  height: 25px;\n}\n", ""]);

// exports
